import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-opacity": ".85",
  "fill-rule": "nonzero",
  d: "M12.714 17a.714.714 0 1 1-1.428 0v-6.429a.714.714 0 1 1 1.428 0zM12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10S2 17.514 2 12 6.486 2 12 2m0 1.435c-4.723 0-8.565 3.842-8.565 8.565S7.277 20.565 12 20.565s8.565-3.843 8.565-8.565c0-4.723-3.843-8.565-8.565-8.565m0 2.85a1.071 1.071 0 1 1 0 2.143 1.071 1.071 0 0 1 0-2.142"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }